import {
    Paper,
    List,
    ListItem,
    ListItemText,
    Typography,
    CircularProgress,
    IconButton,
    ListItemSecondaryAction,
} from '@mui/material';
// import { InfoListItem } from '@brightlayer-ui/react-components';
import React, { useEffect, useState } from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { useHistory } from 'react-router-dom';
import { ContentContainer } from '../../../components/ContentContainer';
import { DataIndicators } from '../../../components/DataIndicators';
import { useUserInfo } from '../../../data/DataProviders/UserInfoProvider';
import { GenericToolbar } from '../../../components/GenericToolbar';
// import MailIcon from '@mui/icons-material/Mail';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PushNotificationSolidIcon from '@brightlayer-ui/icons-mui/PushNotificationSolid';
import LockIcon from '@mui/icons-material/Lock';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { pushAppRoute } from '../../../data/domain/route-manager';
import { isDataLoaded, SiteRoleData, UserOperations, UserRole } from '../../../types';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { isRecordFound, useSelectedOrganizationData, useUserRoles } from '../../../hooks/data-hooks';
import EditIcon from '@mui/icons-material/Edit';
import { useToasts } from '../../../data/DataProviders/ToastProvider';
import { ConfirmationPopUp } from '../../../components/ConfirmationPopUp/ConfirmationPopUp';
import { UserLocation } from '../../../components/UserLocations/UserLocations';
import userStyles from '../UserStyle';
import { useRegistrationRolesData } from '../../../data/DataProviders/RegistrationRoleProvider';
import { disableLocationForEditedUser, bindRoleLocationReadOnlyView, showEditButton } from '../../../lib/user-helpers';
import { useUserRoleLocationData } from '../../../data/DataProviders/UserRoleLocationProvider';
import { UpdateUserLocation } from '../../../components/UpdateUserLocation/UpdateUserLocation';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../../selectors';
import { Actions, Thunks } from '../../../actions';
import { useAppOrganizationData } from '../../../components/AppDataProvider';
import ContentLoader from 'react-content-loader';
import { US_CA_COUNTRY_CODE } from '../../../constants';
// import { EditUserDetails } from '../../../components/EditUserDetails/EditUserDetails';
import { getUserId, useAuthHelper, useAuthState } from '../../../components/AuthContextProvider';
import { useLocationListData } from '../../../data/DataProviders/LocationListDataProvider';
import DeleteIcon from '@mui/icons-material/Delete';
import { UserDetails } from '../../../components/UserDetails/UserDetails';
import { NavigationPromptModal } from '../../../components/NavigationPromptModal/NavigationPromptModal';

export const EditUser: React.FC<{ userId: string }> = (props) => {
    const { t } = useLanguageLocale();
    const authHelper = useAuthHelper();
    const authState = useAuthState();
    const history = useHistory();
    const userInfo = useUserInfo();
    const userData = useSelector(Selectors.User.user); 
    const classes = userStyles();
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const userRoleState = useSelector(Selectors.User.user);
    const registrationState = useSelector(Selectors.Registration.registration);

    const selectedOrganization = useSelectedOrganizationData();
    const locationsList = useLocationListData();
    const loggedinUserRole = useUserRoles();
    const loggedInLocationListData = locationsList[0];
    const registrationRole = useRegistrationRolesData();
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const organizationdata = useAppOrganizationData(orgId);
    const userRoleLocations = useUserRoleLocationData();
    const forgetPasswordLoading = useSelector(Selectors.Authentication.forgotPasswordLoading);
    const forgetPasswordSuccess = useSelector(Selectors.Authentication.forgotPasswordSuccess);
    const forgetPasswordErrorMessage = useSelector(Selectors.Authentication.forgotPasswordErrorMessage);
    const isEmpty = isDataLoaded(userInfo.userInfo) && userInfo.userInfo.value ? false : true;

    const loggedInUserId = getUserId(authState) || '';
    const [edit, setEdit] = useState(false);
    const [editRoles, setEditRoles] = useState(false);
    //const [modifiedUserInfo, setModifiedUserInfo] = useState<UserInfo>(userInfo.userInfo.user.value);

    const [emailStatus, setEmailStatus] = useState(false);
    const [smsStatus, setSmsStatus] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [automaticLogOut, setAutomaticLogOut] = useState(true);
    const [showUserDetailsEdit, setShowUserDetailsEdit] = React.useState(true);
    const [showRoleEdit, setShowRoleEdit] = React.useState(true);
    const [isDirty, setIsDirty] = useState(false);
    const [roleLocationList, setRoleLocationList] = useState<SiteRoleData[]>([]);
    const [siteList, setSiteList] = useState<string[]>([]);
    const [showEdit, setShowEdit] = React.useState(false);
    const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
    const [confirmDiscard, setConfirmDiscard] = useState(false);


    const openSmsDialog = (value: boolean): void => setShowConfirmation(value);
    const openDisclaimer = (): void => setShowDisclaimer(true);

    useEffect(() => {
        if (isDataLoaded(userRoleLocations) && isDataLoaded(loggedInLocationListData)) {
            const val = userRoleLocations.value;
            if (isDataLoaded(val.userLocation) && isDataLoaded(val.userRoles) && isRecordFound(selectedOrganization)) {
                const result = bindRoleLocationReadOnlyView(val.userRoles.value.roles, loggedInLocationListData.value);
                setRoleLocationList(result);
                const siteIds = result.map((role) => role.siteId);
                const hasEatonAdmin = result.every((x) => x.roleName === UserRole.EatonAdmin);
                setSiteList(hasEatonAdmin ? [] : siteIds);
            }
        }
    }, [userRoleLocations]); // eslint-disable-line react-hooks/exhaustive-deps
    const hasDeleteAccess = isRecordFound(loggedinUserRole)
        ? loggedinUserRole.value.some((x) => x.operations.some((operation) => operation === UserOperations.DeleteUser))
        : false;

    const eatonAdmin =
        isRecordFound(loggedinUserRole) &&
        loggedinUserRole.value.find((x) => x.roleName === UserRole.EatonAdmin) &&
        loggedInUserId === props.userId;

    useEffect(() => {
        if (!registrationState.deleteUserLoading && registrationState.deleteUserSuccess) {
            addToast(t('USERLIST.DELETE_SUCCESS'));
            pushAppRoute(history, { type: 'ManageUser', orgId: orgId });
            dispatch(Actions.Registration.deleteUserUnmounted());
        }
    }, [registrationState.deleteUserLoading, registrationState.deleteUserSuccess]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (
            userRoleState.updateRoleSuccess &&
            isDataLoaded(userRoleLocations) &&
            isDataLoaded(registrationRole) &&
            isDataLoaded(loggedInLocationListData) &&
            isRecordFound(selectedOrganization) &&
            isRecordFound(loggedinUserRole)
        ) {
            const disabledLocation = disableLocationForEditedUser(
                roleLocationList,
                loggedInLocationListData.value,
                selectedOrganization.value.id,
                loggedinUserRole.value
            );
            const roleLocations =
                userRoleState.updatedRolesSites.map((roleSites) => {
                    const roleNameById = registrationRole.value.find((x) => x.roleId === roleSites.roleId);

                    return {
                        roleId: (roleNameById && roleNameById.roleId) || '',
                        siteId: roleSites.siteIds,
                        roleName: (roleNameById && roleNameById.roleName) || '',
                        roleDescription: (roleNameById && roleNameById.roleName) || '',
                    };
                }) || [];

            const updatedRoleLocation = bindRoleLocationReadOnlyView(roleLocations, loggedInLocationListData.value);

            const updated =
                updatedRoleLocation.length === 1 &&
                updatedRoleLocation[0].roleName === UserRole.Unassigned &&
                disabledLocation.length > 0
                    ? disabledLocation
                    : [...updatedRoleLocation, ...disabledLocation];
            setRoleLocationList(updated);
            addToast('User Role Updated Successfully');
            dispatch(Actions.UserSettings.updateUserRoleUnmounted());
        }
    }, [userRoleState]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (
            isDataLoaded(userRoleLocations) &&
            isRecordFound(loggedinUserRole) &&
            isDataLoaded(userRoleLocations.value.userRoles) &&
            isDataLoaded(userRoleLocations.value.userLocation)
        ) {
            const loggedInUserRoleValue = loggedinUserRole.value.find((x) => x.roleName === UserRole.LocationAdmin)
                ? UserRole.LocationAdmin
                : loggedinUserRole.value[0].roleName;
            const editVisibility = showEditButton(
                loggedInUserRoleValue as UserRole,
                userRoleLocations.value.userRoles.value.roles,
                loggedInUserId,
                props.userId
            );
            setShowEdit(editVisibility);
        }
    }, [userRoleLocations, loggedinUserRole]); //eslint-disable-line react-hooks/exhaustive-deps

    const user = userInfo.userInfo;
    useEffect(() => {
        if (!forgetPasswordLoading && forgetPasswordSuccess) {
            addToast(t('USERDETAILS.RESET_PASSWORD_SUCCESS'));
            dispatch(Actions.Authentication.resetPasswordReset());
        } else if (forgetPasswordErrorMessage !== '') {
            addToast(t('USERDETAILS.RESET_PASSWORD_ERROR'));
            dispatch(Actions.Authentication.resetPasswordReset());
        }
    }, [forgetPasswordLoading, forgetPasswordSuccess]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isDataLoaded(user)) {
            setEmailStatus(user.value.notification.emailenabled);
            setSmsStatus(user.value.notification.smsenabled);
            setAutomaticLogOut(user.value.session.sessionEnabled);

            const phone =
                user.value.user.phone && user.value.user.phone.length > 10
                    ? user.value.user.phone.slice(-10)
                    : user.value.user.phone || '';
            user.value.user.phone = phone;
            user.value.user.countryCode = US_CA_COUNTRY_CODE;
           // setModifiedUserInfo(user.value);
        }
    }, [user]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isDataLoaded(userInfo.updateUser)) {
            addToast(t('USERDETAILS.EDIT_SUCCESS'));
             setEdit(false);
             setShowUserDetailsEdit(true);
            setShowRoleEdit(true);
            setIsDirty(false);
        }
    }, [userInfo.updateUser]); //eslint-disable-line react-hooks/exhaustive-deps

    const updateEdit = (value: boolean): void => {
        setEdit(value);
        setShowRoleEdit(false);
        setShowUserDetailsEdit(false);
    }

    const onSubmitUserDetails = (firstName: string, lastName: string, email: string, phone: string, countryCode: string): void => {
        userInfo.updateUserInfo(
            props.userId,
            firstName,
            lastName,
            email,
            phone,
            countryCode,
        );
    };

    

    const hasDirty = (value: boolean): void => {
        setIsDirty(value);
        setConfirmDiscard(false);
    };

    const onCancelUserDetails = (): void => {
        setIsDirty(false);
        setEdit(false);
        setShowUserDetailsEdit(true);
        setShowRoleEdit(true);
    };
    const onCancelEditRoles = (): void => {
        setIsDirty(false);
        setEditRoles(false);
        setShowUserDetailsEdit(true);
        setShowRoleEdit(true);
    };
    const handleEmail = (email: boolean): void => {
        setEmailStatus(email);
        userData.loggedInUser.notification.emailenabled=email;
        userInfo.updateEmailNotification(props.userId, email);
    };
    const handleSms = (value: boolean): void => {
        setSmsStatus(value);
        userData.loggedInUser.notification.smsenabled=value;
        userInfo.updateSmsNotification(props.userId, value);
        setShowConfirmation(false);
    };
    const disableAutomaticLogout = (value: boolean): void => {
        setAutomaticLogOut(value);
        userInfo.updateAutomaticLogout(props.userId, value);
        setShowDisclaimer(false);
    };
    const onResetPassword = (email: string): void => {
        dispatch(Thunks.Authentication.forgotPassword(email));
    };
    const closePopUp = (): void => {
        setShowConfirmation(false);
        setShowDisclaimer(false);
        setOpenDeleteConfirmation(false);
    };
    const setDirty = (value: boolean): void => {
        setIsDirty(value);
    };
    const deleteUser = (): void => {
        dispatch(Thunks.Registration.deleteUser(props.userId, siteList, addToast, authHelper));
        setOpenDeleteConfirmation(false);
    };
    return (
        <>
            <GenericToolbar
                title="Settings"
                subtitle="User Profile"
                showBackButton
                backButtonOnClick={(): void => {
                    pushAppRoute(history, { type: 'ManageUser', orgId: orgId });
                }}
            />
            <DataIndicators
                errorMessage="No Data"
                emptyMessage="No Data"
                data={userInfo.userInfo}
                emptyIcon="Person"
                isEmpty={isEmpty}
            />
            <DataIndicators
                errorMessage="No Data"
                emptyMessage="No Data"
                data={registrationRole}
                emptyIcon="Person"
                isEmpty={isEmpty}
            />
            {isDataLoaded(user) && isDataLoaded(registrationRole) && isDataLoaded(userRoleLocations) && (
                <ContentContainer>
                    <>
                        <DataIndicators
                            errorMessage="No Data"
                            emptyMessage="No Data"
                            data={userRoleLocations.value.userLocation}
                            emptyIcon="Person"
                            isEmpty={isEmpty}
                        />
                        <DataIndicators
                            errorMessage="No Data"
                            emptyMessage="No Data"
                            data={userRoleLocations.value.userRoles}
                            emptyIcon="Person"
                            isEmpty={isEmpty}
                        />
                        {!editRoles &&
                            isDataLoaded(userRoleLocations.value.userRoles) &&
                            isDataLoaded(userRoleLocations.value.userLocation) && (
                                <Paper data-testid="organization-card">
                                    <div>
                                        <List
                                            key={'org-name-value'}
                                            component="div"
                                            disablePadding
                                            data-testid="organization"
                                            subheader={
                                                <ListItem
                                                    key="setting-org"
                                                    divider={true}
                                                    style={{ backgroundColor: 'transparent' }}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="h6" color="primary">
                                                                {t('USER_SETTINGS.ORGANIZATION')}
                                                            </Typography>
                                                        }
                                                    ></ListItemText>
                                                    <ListItemSecondaryAction>
                                                        {hasDeleteAccess && showRoleEdit && !eatonAdmin && (
                                                            <>
                                                                {' '}
                                                                {registrationState.deleteUserLoading &&
                                                                !registrationState.deleteUserSuccess ? (
                                                                    <IconButton
                                                                        data-testid="loading-indicator"
                                                                        size="small"
                                                                    >
                                                                        <CircularProgress size="2rem" />
                                                                    </IconButton>
                                                                ) : (
                                                                    <IconButton
                                                                        size="medium"
                                                                        data-testid="delete-action"
                                                                        onClick={(): void => {
                                                                            setOpenDeleteConfirmation(true);
                                                                        }}
                                                                    >
                                                                        <DeleteIcon
                                                                            style={{ color: PXBColors.red[500] }}
                                                                        />
                                                                    </IconButton>
                                                                )}
                                                            </>
                                                        )}
                                                        {showEdit && showRoleEdit && (
                                                            <IconButton
                                                                data-testid="edit-action"
                                                                edge="end"
                                                                aria-label="edit"
                                                                onClick={(): void => {
                                                                    setEditRoles(true);
                                                                    setShowRoleEdit(false);
                                                                    setShowUserDetailsEdit(false);
                                                                }}
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        )}
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            }
                                        >
                                            {roleLocationList.length === 0 &&
                                                !isDataLoaded(organizationdata) &&
                                                !isDataLoaded(loggedInLocationListData) && (
                                                    <ContentLoader
                                                        speed={2}
                                                        width={500}
                                                        height={180}
                                                        viewBox="0 0 500 180"
                                                        color="#f5f5f5"
                                                    >
                                                        <rect x="70" y="52" rx="6" ry="6" width="483" height="50" />
                                                        <circle cx="35" cy="80" r="15" />
                                                    </ContentLoader>
                                                )}
                                            {roleLocationList.length > 0 &&
                                                isDataLoaded(organizationdata) &&
                                                isDataLoaded(loggedInLocationListData) && (
                                                    <UserLocation
                                                        data-testid="user-location"
                                                        key={`${props.userId}roleLocation`}
                                                        location={roleLocationList}
                                                        organizationName={organizationdata.value.name}
                                                    />
                                                )}
                                        </List>
                                    </div>
                                </Paper>
                            )}
                        {editRoles && isDataLoaded(loggedInLocationListData) && (
                            <UpdateUserLocation
                                key={`${props.userId}roleLocationUpdate`}
                                userId={props.userId}
                                registrationRole={registrationRole.value}
                                orgLocationInfo={loggedInLocationListData.value}
                                roleLocationList={roleLocationList}
                                onCancelEdit={onCancelEditRoles}
                                isDirty={setDirty}
                            />
                        )}
                          <UserDetails
                                userId={props.userId}
                                userData={user.value}
                                userState={userRoleState}
                                userInfo = { userInfo}
                                userUpdateLoading={userRoleState.userDetailLoading}
                                onSubmit={onSubmitUserDetails}
                                openSMSModal={openSmsDialog}
                                openDisclaimer={openDisclaimer}
                                disableAutomaticLogout={disableAutomaticLogout}
                                hasDirty={hasDirty}
                                confirmDiscard={confirmDiscard}
                                onResetPassword={onResetPassword}
                                loggedinUser={false}
                                loggedUser={loggedInUserId === props.userId ? true : false}
                                handleEmail={handleEmail}
                                handleSms={handleSms}
                                emailStatus={emailStatus}
                                smsStatus={smsStatus}
                                automaticLogOut={automaticLogOut}
                                edit={edit}
                                updateEdit={updateEdit}
                                handleCancelClick={onCancelUserDetails}
                                showUserDetailsEdit={showUserDetailsEdit}
                            ></UserDetails>
                    </>
                </ContentContainer>
            )}
            {showConfirmation && (
                <ConfirmationPopUp
                    icon={<PushNotificationSolidIcon className={classes.largeIcon} />}
                    title={t('USER_SETTINGS.TEXT_NOTIFICATION_TITLE')}
                    body={<Typography> {t('USER_SETTINGS.TEXT_NOTIFICATION_BODY')}</Typography>}
                    okButtonText={t('ACTIONS.ENABLE')}
                    cancelButtonText={t('ACTIONS.CANCEL')}
                    show={showConfirmation}
                    closeDialog={closePopUp}
                    handleOk={handleSms}
                    width="xs"
                    okButtonShow={true}
                    cancelButtonsShow={true}
                ></ConfirmationPopUp>
            )}
            {showDisclaimer && (
                <ConfirmationPopUp
                    icon={<LockIcon className={classes.largeIcon} />}
                    title={t('USER_SETTINGS.AUTOMATIC_LOGOUT_TITLE')}
                    body={
                        <>
                            <Typography variant="subtitle2" style={{ marginBottom: 30 }}>
                                {t('USER_SETTINGS.AUTOMATIC_LOGOUT_SUBTITLE')}
                            </Typography>

                            <Typography variant="subtitle2" component="p" style={{ marginBottom: 40 }}>
                                <b>{t('USER_SETTINGS.WARNING')}</b>: {t('USER_SETTINGS.AUTOMATIC_LOGOUT_BODY')}
                            </Typography>
                        </>
                    }
                    okButtonText={t('ACTIONS.DISABLE')}
                    cancelButtonText={t('ACTIONS.CANCEL')}
                    show={showDisclaimer}
                    closeDialog={closePopUp}
                    handleOk={(): void => {
                        disableAutomaticLogout(false);
                    }}
                    width="xs"
                    okButtonShow={true}
                    cancelButtonsShow={true}
                ></ConfirmationPopUp>
            )}
            {openDeleteConfirmation && (
                <ConfirmationPopUp
                    title={t('USERLIST.DELETEACCOUNT')}
                    body={
                        <Typography variant="subtitle2" style={{ marginBottom: 30 }}>
                            {t('USERLIST.DELETECONFIRMATION')}
                        </Typography>
                    }
                    okButtonText={t('ACTIONS.DELETE')}
                    cancelButtonText={t('ACTIONS.CANCEL')}
                    show={openDeleteConfirmation}
                    closeDialog={closePopUp}
                    handleOk={(): void => {
                        deleteUser();
                    }}
                    width="xs"
                    okButtonShow={true}
                    cancelButtonsShow={true}
                ></ConfirmationPopUp>
            )}
            <NavigationPromptModal isDirty={isDirty} />
        </>
    );
};